import { useState, useCallback } from "react";
import { useShowMessage } from "../../hooks/useShowMessage";
import { MessageType } from "../../contexts/MessageContext";

interface CopyButtonProps {
  textToCopy: string;
}

const CopyButton = ({ textToCopy }: CopyButtonProps) => {
  const [icon, setIcon] = useState("📋");
  const [animate, setAnimate] = useState(false);
  const showMessage = useShowMessage();

  const copyToClipboard = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIcon("✅");
      setAnimate(true);
      const timer = setTimeout(() => {
        setIcon("📋");
        setAnimate(false);
      }, 1500);
      return () => clearTimeout(timer);
    } catch (err) {
      await showMessage("Failed to copy to clipboard", MessageType.Error);
    }
  }, [textToCopy, showMessage]);

  return (
    <button
      onClick={copyToClipboard}
      className={`w-9 h-9 flex items-center justify-center px-2 bg-green-300 hover:bg-green-400 active:bg-green-500 text-black font-bold rounded transition-transform duration-300 ${animate ? "scale-110" : ""}`}
      aria-label="Copy slides to clipboard"
    >
      {icon}
    </button>
  );
};

export default CopyButton;
